<script setup>
import BaseNotificationCard from './BaseNotificationCard.vue';

// Ren presentasjons-komponent: tar inn notifikasjoner som prop og rendrer aktive
// som toast-kort. Notifications-state håndteres av en wrapper-komponent (se
// AppToastHost.vue) som leser notificationsStore og fôrer denne.
defineProps({
  notifications: {
    type: Array,
    default: () => []
  }
});
</script>

<template>
  <!-- Bug #1944: ankret OVER footer-/knappe-sonen (bottom-20) — bottom-5 dekket
       «Neste»-knappen i wizard-footeren. -->
  <div class="fixed bottom-20 right-5 z-[2000] flex flex-col-reverse gap-2.5">
    <TransitionGroup name="toast">
      <BaseNotificationCard
        v-for="notification in notifications.filter(n => n.isActive)"
        :key="notification.id"
        :notification="notification"
      />
    </TransitionGroup>
  </div>
</template>
